import o from "./td-longtail-vue-components230.js";
/* empty css                              */
import r from "./td-longtail-vue-components98.js";
var a = function() {
  var t = this, e = t._self._c, n = t._self._setupProxy;
  return e("div", { staticClass: "dropdown-item-content" }, [t._t("before"), e("div", { staticClass: "dropdown-item-content__label", class: { "dropdown-item-content__label--break": t.breakText } }, [t._t("default", function() {
    return [e("span", { domProps: { innerHTML: t._s(t.label) } })];
  })], 2), n.hasCount ? e("span", { staticClass: "dropdown-item-content__count", attrs: { "aria-label": `Verfügbare Artikel: ${t.count}`, "data-nosnippet": "" } }, [t._v(" " + t._s(t.count) + " ")]) : t._e(), e("span", { staticClass: "dropdown-item-content__indicator", class: { "dropdown-item-content__indicator--active": t.selected } })], 2);
}, s = [], _ = /* @__PURE__ */ r(
  o,
  a,
  s,
  !1,
  null,
  null
);
const p = _.exports;
export {
  p as default
};
